export enum ProfileRoutePathsEnum {
  PROFILE = '/profile',
  SETTINGS = '/settings',
}
